import React from 'react'

function LogoOnly() {
  return (
    <img
      src="/icon-192x192.png"
      alt=""
      style={{ height: '70px', width: '80px' }}
    />
  )
}

export default LogoOnly
